import React from 'react';
import Header from '../components/Header';
import Button from '../components/Button';
import CommentArchieve from '../components/Comment';
import { ArchieveData, Comment } from '../models/card';
import { Link } from "react-router-dom";
import * as Utility from '../utils/Utility';
import { CircularProgress } from '@material-ui/core';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

interface ArchieveProps {
    theme?: string;
    className?: string;
    link?: string;
    match?: any;
    firebase?: any;
    history?: any;
}

interface ArchieveState {
    archieve: ArchieveData;
    isLoading: boolean;
    additionComment: string;
    subscription: any;
}

class Archieve extends React.PureComponent<ArchieveProps, ArchieveState> {
    fireBaseUpdateSubscription: any;
    constructor(props: any) {
        super(props);
        this.state = { isLoading: true, additionComment: '', archieve: new ArchieveData(), subscription: null };
    }
    componentDidMount() {
        const id = this.props.match.params.id;
        const query = this.props.firebase.database().ref('archieve/' + id);
        query.on('value', (data: any) => {
            const archieve: ArchieveData = data.val();
            this.setState({ archieve: archieve, isLoading: false });
        }, (err: any) => { 
            this.props.history.push('/NOT_FOUND');
        });
    }

    componentWillUnmount() {
        this.fireBaseUpdateSubscription && this.fireBaseUpdateSubscription();
    }

    onChangeTextArea = (e: any) => {
        this.setState({ additionComment: e.target.value });
    }

    addComment = () => {
        const id = this.props.match.params.id;
        const comment: Comment = new Comment();
        comment.data = this.state.additionComment;
        const commentFromFirebase = this.state.archieve?.comments ? this.state.archieve?.comments : [];
        const newComments = [...commentFromFirebase, comment];
        this.props.firebase.database().ref('archieve/' + id).child('/comments').set(newComments).then(
            () => { this.setState({additionComment: ''})}
        );
    }

    setReputation = (index: number) => {
        const id = this.props.match.params.id;
        const newComments: Comment[] = [...this.state.archieve.comments];
        newComments[index].reputation = newComments[index].reputation + 1;
        this.props.firebase.database().ref('archieve/' + id).child('/comments').set(newComments);
    }

    hashTageName = (archieve: ArchieveData) => {
        let hashtag = archieve.name.replace('|', '');
        if(!archieve.isShow){
            hashtag = '#โทสะ';
        }
        return hashtag;
    }
    
    genDescription = (archieve: ArchieveData) => {
        let description: any = archieve.description;
        if(!archieve.isShow){
            description = 'ผู้บรรยายหรือกองบรรณาธิการตกลงให้ปกปิดเนื้อหาเพื่อความปลอดภัยของผู้มีส่วนเกี่ยวข้อง';
        }
        return description;
    }
    
    genCategory = (archieve: ArchieveData) => {
        let description: any = (<span> การเมือง(ปกปิดข้อมูล) </span>);
        if(archieve.isShow){
            description = archieve.categories?.map((category,index) => (
                <span key={index}> {category} </span>
            ))
        }
        return description;
    }

    onClickGoBack = () => {
        this.props.history.goBack();
    }

    render() {
        const { archieve, isLoading, additionComment } = this.state;
        const { className } = this.props;
        const archeiveTweet = archieve?.noOfTweets ? archieve?.noOfTweets : 0;
        const angerClass = archieve.isShow ? '' : 'card-anger';
        const noOfTweet = Utility.numberWithCommas(archeiveTweet);
        let hashTag = this.hashTageName(archieve);
        let category = this.genCategory(archieve);
        let description = this.genDescription(archieve);
        if (isLoading) {
            return (
                <React.Fragment>
                    <Header className={'m-0'} />
                    <div className='container-center' style={{ margin: '40px' }}>
                        <CircularProgress color={"primary"} style={{ color: '#fcd745' }} size={120} thickness={2.0} />
                    </div>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <Header className={'m-0'} />
                <div className={`${className ? className : ''}`} >
                    <div className={`card-archieve ${angerClass}`} style={{ width: '100%', maxHeight: '800px', height: '100%', cursor: 'auto' }}>
                        <div className="row">
                            <div className="col-6">
                                <div className="sub-title" style={{ float: 'left', fontSize: '24px' }}>{archieve?.date ? archieve?.date : ''}</div>
                            </div>
                            <div className="col-6">
                                <div className="sub-title" >
                                    <CloseOutlinedIcon onClick={() => {this.onClickGoBack()}} className={`close-outline`} />
                                </div>
                            </div>
                        </div>
                        <h4 style={{ fontSize: '40px' }} className="title">{hashTag}</h4>
                        <div className="row">
                            <div className="col-8" style={{ fontSize: '24px' }}>
                                {category}
                            </div>
                            <div className="col-4">
                                <div className="text-right">
                                    <h4>{noOfTweet}</h4>
                                    <p style={{ marginBottom: '5px' }}>Volume (Tweets)</p>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div style={{ overflow: 'scroll' }}>
                            <div style={{ fontSize: '24px' }}>
                                {description}
                            </div>
                            <div style={{ height: '10px' }}> </div>
                            <div>
                                {
                                    archieve?.comments?.map((data: Comment, index: number) => (
                                        <CommentArchieve key={index} index={index} comment={data} setReputation={() => { this.setReputation(index) }} />
                                    ))
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-10">
                                <textarea style={{ width: '100%', fontWeight: 100, color: 'inherit' }} maxLength={400} value={additionComment} onChange={(e: any) => { this.onChangeTextArea(e) }} rows={2}></textarea>
                            </div>
                            <div className="col-2">
                                <div className="mt-20" style={{ cursor: 'pointer' }}>
                                    <Button text={'+ สิ้นสุดการบรรยาย'} onClickBtn={() => {this.addComment()}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Archieve;